import React, { useCallback } from 'react';
import { useRouter } from 'next/router';
import styles from './index.module.scss';

const Navbar = () => {
  const router = useRouter();

  const handleClick = useCallback(
    (e) => {
      if (router.pathname === '/island') {
        e.preventDefault();
        if (typeof window !== 'undefined') {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          setTimeout(() => {
            const emailInput = document.getElementById(
              'newsletter-email-signup'
            );
            if (emailInput) {
              emailInput.focus();
            }
          }, 500);
        }
        return;
      }
      e.preventDefault();
      router.push('/island').then(() => {
        if (typeof window !== 'undefined') {
          setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            // Focus on email input after navigation and scrolling
            setTimeout(() => {
              const emailInput = document.getElementById(
                'newsletter-email-signup'
              );
              if (emailInput) {
                emailInput.focus();
              }
            }, 500);
          }, 50);
        }
      });
    },
    [router]
  );

  return (
    <header className={styles.navbar} role="banner">
      <div className={styles.inner}>
        <a href="/island" className={styles.brand} aria-label="BF Island Home">
          <img
            src="/static/images/island-mark.jpg"
            alt="Island logo"
            className={styles.brandLogo}
          />
          <span className={styles.brandDim}>BF&nbsp;</span>
          <span className={`${styles.brandBright} ${styles.brandWordStart}`}>
            Isl
          </span>
          <span className={styles.brandTilt}>a</span>
          <span className={styles.brandBright}>nd</span>
        </a>
        <nav className={styles.actions} aria-label="Primary">
          <a
            href="/island"
            className={styles.ctaButton}
            aria-label="Scroll to top of island page"
            onClick={handleClick}
          >
            <span className={styles.ctaText}>Join the Waitlist</span>
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
